export default "__VITE_ASSET__koLa57T9__"